const Login = () => import('@/views/pages/Login.vue');
const Logout = () => import('@/views/pages/Logout.vue');

const Forget = () => import('@/views/pages/Forget.vue');
const UpdatePassword = () => import('@/views/pages/UpdatePassword.vue');
const Register = () => import('@/views/pages/Register.vue');
const SetPass = () => import('@/views/pages/SetPass.vue');
const DefaultContainer = () => import('@/containers/DefaultContainer.vue');
const Dashboard = () => import('@/views/admin/Dashboard.vue');

const CampaignTemplate = () => import('@/views/pages/CampaignTemplate.vue');

const addUsers = () => import('@/views/admin/Users/Add.vue');
const editUsers = () => import('@/views/admin/Users/Edit.vue');
const listUsers = () => import('@/views/admin/Users/List.vue');

const addRole = () => import('@/views/admin/Roles/Add.vue');
const editRole = () => import('@/views/admin/Roles/Edit.vue');
const listRoles = () => import('@/views/admin/Roles/List.vue');

const addAgreements = () => import('@/views/admin/Agreements/Add.vue');
const editAgreements = () => import('@/views/admin/Agreements/Edit.vue');
const listAgreements = () => import('@/views/admin/Agreements/List.vue');

const listDepartments = () => import('@/views/admin/Departments/List.vue');
const listBanks = () => import('@/views/admin/Banks/List.vue');
const listUnsubscribes = () => import('@/views/partners/Unsubscribes/List.vue');

const listCNAE = () => import('@/views/partners/CNAE/List.vue');

const addHeadquarters = () => import('@/views/admin/Headquarters/Add.vue');
const editHeadquarters = () => import('@/views/admin/Headquarters/Edit.vue');
const listHeadquarters = () => import('@/views/admin/Headquarters/List.vue');

const addPartners = () => import('@/views/partners/accounts/wizard/Parent.vue');
const editPartners = () => import('@/views/partners/accounts/Edit/Parent.vue');
const listNoPartners = () => import('@/views/partners/no-accounts/List.vue');
const listPartners = () => import('@/views/partners/accounts/List.vue');
const searchPartners = () => import('@/views/partners/accounts/Searcher.vue');

const editDocuments = () => import('@/views/admin/Documents/Edit.vue');
const listDocuments = () => import('@/views/admin/Documents/List.vue');

const listSchedule = () => import('@/views/admin/Schedule/List.vue');

const generalParameters = () => import('@/views/admin/Parameters/GeneralParameters.vue');

const listQueries = () => import('@/views/queries/Query/ListQueries.vue');
const addQuery = () => import('@/views/queries/Query/AddQuery.vue');
const editQuery = () => import('@/views/queries/Query/EditQuery.vue');
const queryOverview = () => import('@/views/queries/Query/QueryOverview.vue');
const queryDailyReport = () => import('@/views/queries/Query/QueryDailyReport.vue');

const addQueryCategory = () => import('@/views/queries/QueryCategories/Add.vue');
const editQueryCategory = () => import('@/views/queries/QueryCategories/Edit.vue');
const listQueryCategories = () => import('@/views/queries/QueryCategories/List.vue');

const listQueryIssueTypes = () => import('@/views/queries/QueryIssueTypes/ListQueryIssueTypes.vue');

const addQueryAnswerType = () => import('@/views/queries/QueryAnswerTypes/AddQueryAnswerType.vue');
const editQueryAnswerType = () => import('@/views/queries/QueryAnswerTypes/EditQueryAnswerType.vue');
const listQueryAnswerTypes = () => import('@/views/queries/QueryAnswerTypes/ListQueryAnswerTypes.vue');

const listQueryRatings = () => import('@/views/queries/QueryRatings/ListQueryRatings.vue');

const listNotifications = () => import('@/views/profile/notifications/ListNotifications.vue');

const listAssociatedProject = () => import('@/views/admin/AssociatedProjects/ListAssociatedProject.vue');
const addAssociatedProject = () => import('@/views/admin/AssociatedProjects/AddAssociatedProject.vue');
const editAssociatedProject = () => import('@/views/admin/AssociatedProjects/EditAssociatedProject.vue');

const querySurvey = () => import('@/views/survey/query/QuerySurvey.vue');

const listRefunds = () => import('@/views/accounting/Refunds/List.vue');
const addConsignment = () => import('@/views/accounting/Consignments/AddConsignment.vue');
const listConsignments = () => import('@/views/accounting/Consignments/ListConsignments.vue');
const consignmentOverview = () => import('@/views/accounting/Consignments/ConsignmentOverview.vue');


const listFeeTypes = () => import('@/views/admin/FeeTypes/ListFeeTypes.vue');

const listBankReturns = () => import('@/views/accounting/BankReturns/ListBankReturns.vue');
const bankReturnOverview = () => import('@/views/accounting/BankReturns/BankReturnOverview.vue');

const listReceipts = () => import('@/views/accounting/Receipts/ListReceipts.vue');
const editReceipt = () => import('@/views/accounting/Receipts/EditReceipt.vue');
const addReceipt = () => import('@/views/accounting/Receipts/AddReceipt.vue');

const accountingTable = () => import('@/views/statistics/AccountingTable.vue');

const listSearch = () => import('@/views/search/List.vue');
const addSearch = () => import('@/views/search/wizard/parent.vue');
const searchOverview = () => import('@/views/search/SearchOverview.vue');
const searchTable = () => import('@/views/search/SearchTable.vue');

const listContacts = () => import('@/views/communications/contacts/List.vue');
const addContact = () => import('@/views/communications/contacts/Add.vue');
const editContact = () => import('@/views/communications/contacts/Edit.vue');

const unsubscribeContact = () => import('@/views/communications/contacts/Unsubscribe.vue');
const unsubscribeClient = () => import('@/views/partners/accounts/Unsubscribe.vue');

const listDistributionList = () => import('@/views/communications/distributionList/List.vue');

const addDistributionList = () => import('@/views/communications/distributionList/Add.vue');

const listContactForDistributionList = () => import('@/views/communications/distributionList/ListContacts.vue');

const searchPartnersForDistributionList = () => import('@/views/communications/distributionList/search.vue');

const editDistributionList = () => import('@/views/communications/distributionList/Edit.vue');
const listCampaigns = () => import('@/views/communications/campaign/List.vue');
const addCampaign = () => import('@/views/communications/campaign/Add.vue');
const editCampaign = () => import('@/views/communications/campaign/Edit.vue');
const statisticsCampaign = () => import('@/views/communications/statistics/Statistics.vue');
const listCampaignTypes = () => import('@/views/communications/campaignType/List.vue');
const addCampaignType = () => import('@/views/communications/campaignType/Add.vue');
const editCampaignType = () => import('@/views/communications/campaignType/Edit.vue');

export default [
    {
        path: '/',
        redirect: '/login',
        name: 'home',
        meta: {
            requiresGuest: true
        }
    },
    {
        path: '/campaign-template/:uuid',
        name: 'campaignTemplate',
        component: CampaignTemplate,
        meta: {
            requiresGuest: true
        }
    },
    {
        path: '/survey/query',
        name: 'querySurvey',
        component: querySurvey,
        meta: {
            requiresGuest: true
        }
    },
    {
        path: '/admin',
        redirect: '/admin/dashboard',
        name: 'admin',
        component: DefaultContainer,
        children: [
            {
                path: 'dashboard',
                name: 'dashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'user',
                name: 'user',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'add',
                        name: 'addUser',
                        component: addUsers,
                        meta: {
                            requiresAuth: true,
                            title: 'Nuevo Usuario'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editUser',
                        component: editUsers,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Usuario'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listUser',
                        component: listUsers,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Usuarios'
                        }
                    }
                ]
            },
            {
                path: 'departments',
                name: 'departments',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listDepartments',
                        component: listDepartments,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Departamentos'
                        }
                    }
                ]
            },
            {
                path: 'schedule',
                name: 'schedule',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                }, children: [
                    {
                        path: 'list',
                        name: 'listSchedule',
                        component: listSchedule,
                        meta: {
                            requiresAuth: true,
                            title: 'Agenda'
                        }
                    }
                ]
            },
            {
                path: 'banks',
                name: 'banks',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listBanks',
                        component: listBanks,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestiones Bancarias'
                        }
                    }
                ]
            },
            {
                path: 'headquarters',
                name: 'headquarters',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'add',
                        name: 'addHeadquarters',
                        component: addHeadquarters,
                        meta: {
                            requiresAuth: true,
                            title: 'Nueva Sede'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listHeadquarters',
                        component: listHeadquarters,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Sedes'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editHeadquarters',
                        component: editHeadquarters,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Sede'
                        }
                    }
                ]
            },
            {
                path: 'documents',
                name: 'documents',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listDocuments',
                        component: listDocuments,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Documentos'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editDocuments',
                        component: editDocuments,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Documento'
                        }
                    }
                ]
            },
            {
                path: 'agreements',
                name: 'agreements',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'add',
                        name: 'addAgreements',
                        component: addAgreements,
                        meta: {
                            requiresAuth: true,
                            title: 'Nuevo Convenio'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editAgreements',
                        component: editAgreements,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Convenio'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listAgreements',
                        component: listAgreements,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Convenios'
                        }
                    }
                ]
            },
            {
                path: 'parameters',
                name: 'parameters',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'general',
                        name: 'generalParameters',
                        component: generalParameters,
                        meta: {
                            requiresAuth: true,
                            title: 'Parámetros Generales'
                        }
                    }
                ]
            },
            {
                path: 'roles',
                name: 'roles',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'add',
                        name: 'addRole',
                        component: addRole,
                        meta: {
                            requiresAuth: true,
                            title: 'Nuevo Rol'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editRole',
                        component: editRole,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Rol'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listRoles',
                        component: listRoles,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Roles'
                        }
                    }
                ]
            },
            {
                path: 'associated-projects',
                name: 'associated-projects',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'add',
                        name: 'addAssociatedProject',
                        component: addAssociatedProject,
                        meta: {
                            requiresAuth: true,
                            title: 'Nuevo Proyecto Asociado'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editAssociatedProject',
                        component: editAssociatedProject,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Proyecto Asociado'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listAssociatedProject',
                        component: listAssociatedProject,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Proyectos Asociados'
                        }
                    }
                ]
            },
            {
                path: 'fee-types',
                name: 'fee-types',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listFeeTypes',
                        component: listFeeTypes,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Tipos de Cuotas'
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/queries',
        name: 'queries',
        component: DefaultContainer,
        children: [
            {
                path: 'add',
                name: 'addQuery',
                component: addQuery,
                meta: {
                    requiresAuth: true,
                    title: 'Nueva Consulta'
                }
            },
            {
                path: 'list',
                name: 'queriesList',
                component: listQueries,
                meta: {
                    requiresAuth: true,
                    title: 'Listado de Consultas'
                }
            },
            {
                path: 'edit/:uuid',
                name: 'editQuery',
                component: editQuery,
                meta: {
                    requiresAuth: true,
                    title: 'Editar Consulta'
                }
            },
            {
                path: 'overview/:uuid',
                name: 'queryOverview',
                component: queryOverview,
                meta: {
                    requiresAuth: true,
                    title: 'Ficha de Consulta'
                }
            },
            {
                path: 'report',
                name: 'queryDailyReport',
                component: queryDailyReport,
                meta: {
                    requiresAuth: true,
                    title: 'Informe Diario del Asesor'
                }
            },
            {
                path: 'categories',
                name: 'queryCategories',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'add',
                        name: 'addQueryCategory',
                        component: addQueryCategory,
                        meta: {
                            requiresAuth: true,
                            title: 'Nueva Categoría'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editQueryCategory',
                        component: editQueryCategory,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Categoría'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listQueryCategories',
                        component: listQueryCategories,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Categoría de Consulta'
                        }
                    }
                ]
            },
            {
                path: 'issue-types',
                name: 'queryIssueTypes',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listQueryIssueTypes',
                        component: listQueryIssueTypes,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Tipos de Incidencias de Consulta'
                        }
                    }
                ]
            },
            {
                path: 'answer-types',
                name: 'queryAnswerTypes',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'add',
                        name: 'addQueryAnswerType',
                        component: addQueryAnswerType,
                        meta: {
                            requiresAuth: true,
                            title: 'Nueva Respuesta'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editQueryAnswerType',
                        component: editQueryAnswerType,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Respuesta'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listQueryAnswerTypes',
                        component: listQueryAnswerTypes,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Tipos de Respuesta de Consulta'
                        }
                    }
                ]
            },
            {
                path: 'ratings',
                name: 'queryRatings',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listQueryRatings',
                        component: listQueryRatings,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Encuestas'
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/partners',
        redirect: '/admin/dashboard',
        name: 'partners',
        component: DefaultContainer,
        children: [
            {
                path: 'dashboard',
                name: 'partnersDashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'no-accounts',
                name: 'no-accounts',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listNoPartners',
                        component: listNoPartners,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de No Socios'
                        }
                    }
                ]
            },
            {
                path: 'accounts', name: 'partnersAccounts', component: {
                    render(c) {
                        return c('router-view')
                    }
                }, children: [
                    {
                        path: 'add',
                        name: 'addPartner',
                        component: addPartners,
                        meta: {
                            requiresAuth: true,
                            title: 'Alta de Nuevo Socio'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editPartner',
                        component: editPartners,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Socio'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listPartners',
                        component: listPartners,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Socios'
                        }
                    },
                    {
                        path: 'search',
                        name: 'searchPartners',
                        component: searchPartners,
                        meta: {
                            requiresAuth: true,
                            title: 'Búsqueda Avanzada de Socios'
                        }
                    }
                ]
            },
            {
                path: 'unsubscribes',
                name: 'unsubscribes',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listUnsubscribes',
                        component: listUnsubscribes,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Bajas'
                        }
                    }
                ]
            },
            {
                path: 'cnae',
                name: 'cnae',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listCnae',
                        component: listCNAE,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de CNAE'
                        }
                    }
                ]
            },
        ]
    },
    {
        path: '/accounting',
        redirect: '/admin/dashboard',
        name: 'accounting',
        component: DefaultContainer,
        children: [
            {
                path: 'dashboard',
                name: 'accountingDashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'refunds',
                name: 'refunds',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                }, children: [
                    {
                        path: 'list',
                        name: 'listRefunds',
                        component: listRefunds,
                        meta: {
                            requiresAuth: true,
                            title: 'Motivos de devolución'
                        }
                    }
                ]
            },
            {
                path: 'consignments',
                name: 'consignments',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                }, children: [
                    {
                        path: 'add',
                        name: 'addConsignment',
                        component: addConsignment,
                        meta: {
                            requiresAuth: true,
                            title: 'Nueva Remesa'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listConsignments',
                        component: listConsignments,
                        meta: {
                            requiresAuth: true,
                            title: 'Listado de Remesas'
                        }
                    },
                    {
                        path: ':uuid/overview',
                        name: 'consignmentOverview',
                        component: consignmentOverview,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Remesa'
                        }
                    }
                ]
            },
            {
                path: 'bank-returns',
                name: 'bankReturns',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                }, children: [
                    {
                        path: 'list',
                        name: 'listBankReturns',
                        component: listBankReturns,
                        meta: {
                            requiresAuth: true,
                            title: 'Devoluciones'
                        }
                    },
                    {
                        path: ':uuid/overview',
                        name: 'bankReturnOverview',
                        component: bankReturnOverview,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Devoluciones'
                        }
                    }
                ]
            },
            {
                path: 'receipts',
                name: 'receipts',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                }, children: [
                    {
                        path: 'list',
                        name: 'listReceipts',
                        component: listReceipts,
                        meta: {
                            requiresAuth: true,
                            title: 'Listado de Recibos'
                        }
                    },
                    {
                        path: ':uuid/edit',
                        name: 'editReceipt',
                        component: editReceipt,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Recibo'
                        }
                    },
                    {
                        path: 'add',
                        name: 'addReceipt',
                        component: addReceipt,
                        meta: {
                            requiresAuth: true,
                            title: 'Agregar Recibo'
                        }
                    }
                ]
            }
        ]
    },
    {
        path: '/communications',
        redirect: '/admin/dashboard',
        name: 'communications',
        component: DefaultContainer,
        children: [
            {
                path: 'contacts',
                name: 'contacts',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'add',
                        name: 'addContact',
                        component: addContact,
                        meta: {
                            requiresAuth: true,
                            title: 'Nuevo contacto'
                        }
                    },
                    {
                        path: 'edit/:uuid',
                        name: 'editContact',
                        component: editContact,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Contacto'
                        }
                    },
                    {
                        path: 'list',
                        name: 'listContacts',
                        component: listContacts,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de contactos'
                        }
                    }
                ]
            },
            {
                path: 'distribution-list',
                name: 'distributionList',
                component: {
                  render(c) {
                    return c('router-view')
                  }
                },
                children: [
                  {
                    path: '/communications/distribution-list/add',
                    name: 'addDistributionList',
                    component: addDistributionList,
                    meta: {
                      requiresAuth: true,
                      title: 'Nuevo lista de distribución'
                    }
                  },
                  {
                    path: '/communications/distribution-list/list-contact',
                    name: 'ListContactForDistributionList',
                    component: listContactForDistributionList,
                    meta: {
                      requiresAuth: true,
                      title: 'Lista de contactos para lista de distribución'
                    }
                  },
                  {
                    path: '/communications/distribution-list/search',
                    name: 'SearchPartnersForDistributionList',
                    component: searchPartnersForDistributionList,
                    meta: {
                      requiresAuth: true,
                      title: 'Lista de contactos para lista de distribución'
                    }
                  },
                  {
                    path: 'list',
                    name: 'listDistributionLists',
                    component: listDistributionList,
                    meta: {
                      requiresAuth: true,
                      title: 'Gestión de listas de distribución'
                    }
                  },
                  {
                    path: '/communications/distribution-list/edit/:uuid',
                    name: 'editDistributionLists',
                    component: editDistributionList,
                    meta: {
                      requiresAuth: true,
                      title: 'Ficha de listas de distribución'
                    }
                  }
                ]
            },
            {
              path: 'campaign',
              name: 'campaign',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: 'list',
                  name: 'listCampaigns',
                  component: listCampaigns,
                  meta: {
                    requiresAuth: true,
                    title: 'Gestión de Campañas'
                  }
                },
                {
                  path: 'add',
                  name: 'addCampaign',
                  component: addCampaign,
                  meta: {
                    requiresAuth: true,
                    title: 'Nuevo Campaña'
                  }
                },
                {
                  path: 'edit/:uuid',
                  name: 'editCampaign',
                  component: editCampaign,
                  meta: {
                    requiresAuth: true,
                    title: 'Ficha de Campaña'
                  }
                },
                {
                  path: '/communications/statistics/Statistics',
                  name: 'statisticsCampaign',
                  component: statisticsCampaign,
                  meta: {
                    requiresAuth: true,
                    title: 'Estadísticas Campaña'
                  }
                },
              ]
            },
            {
                path: 'campaign-type',
                name: 'campaignType',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'list',
                        name: 'listCampaignTypes',
                        component: listCampaignTypes,
                        meta: {
                            requiresAuth: true,
                            title: 'Gestión de Tipos de Campañas'
                        }
                    },
                    {
                        path: 'add',
                        name: 'addCampaignType',
                        component: addCampaignType,
                        meta: {
                            requiresAuth: true,
                            title: 'Nuevo Tipo de Campaña'
                        }
                    },
                    {
                        path: '/communications/campaignType/edit/:uuid',
                        name: 'editCampaignType',
                        component: editCampaignType,
                        meta: {
                            requiresAuth: true,
                            title: 'Ficha de Tipo de Campaña'
                        }
                    }
                ]
            },
        ]
    },
    {
        path: '/statistics',
        redirect: '/admin/dashboard',
        name: 'statistics',
        component: DefaultContainer,
        children: [
            {
                path: 'dashboard',
                name: 'statisticsDashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'accounting-table',
                name: 'accountingTable',
                component: accountingTable,
                meta: {
                    requiresAuth: true,
                    title: 'Cuadro Contable'
                }
            }
        ]
    },
    {
        path: '/search',
        name: 'search',
        component: DefaultContainer,
        children: [
            {
                path: '/search/add',
                name: 'addSearch',
                component: addSearch,
                meta: {
                    requiresAuth: true,
                    title: 'Nueva Búsqueda'
                }
            },
            {
                path: '/search/list',
                name: 'listSearch',
                component: listSearch,
                meta: {
                    requiresAuth: true,
                    title: 'Listado de Búsquedas'
                }
            },
            {
              path: ':uuid/overview',
              name: 'searchOverview',
              component: searchOverview,
              meta: {
                requiresAuth: true,
                title: 'Ficha de Búsquedas'
              }
            },
            {
              path: 'search-table',
              name: 'searchTable',
              component: searchTable,
              meta: {
                requiresAuth: true,
                title: 'Búsquedas Contable'
              }
            }
        ]
    },
    {
        path: '/profile',
        redirect: '/profile/notifications',
        name: 'profile',
        component: DefaultContainer,
        children: [
            {
                path: 'notifications',
                name: 'listNotifications',
                component: listNotifications,
                meta: {
                    requiresAuth: true,
                    title: 'Notificaciones'
                }
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            guest: true
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: Logout,
        meta: {requiresAuth: true},
    },
    {
        path: '/forget',
        name: 'forget',
        component: Forget,
        meta: {requiresGuest: true},
    },
    {
        path: '/update-password',
        name: 'updatePassword',
        component: UpdatePassword,
        meta: {requiresGuest: true},
    },
    {
        path: '/setpassword',
        name: 'setpass',
        component: SetPass,
        meta: {requiresGuest: true},
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {requiresGuest: true},
    },
  {
    path: '/communications/contacts/unsubscribe',
    name: 'unsubscribeContact',
    component: unsubscribeContact,
    meta: {
      requiresGuest: false
    }
  },
  {
    path: '/partners/accounts/unsubscribe',
    name: 'unsubscribeClient',
    component: unsubscribeClient,
    meta: {
      requiresGuest: false
    }
  },
];
